import { render, staticRenderFns } from "./ApiDialog.vue?vue&type=template&id=28829bef&scoped=true&"
import script from "./ApiDialog.vue?vue&type=script&lang=js&"
export * from "./ApiDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApiDialog.vue?vue&type=style&index=0&id=28829bef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28829bef",
  null
  
)

export default component.exports